import { useState, useEffect, useCallback, useMemo } from 'react';
import './style.css';
import AlertMessage from '../../Alert';
import { CardContent } from '../../CardContent';
import { Title } from '../../Title';
import { Button, Col, Row } from 'react-bootstrap';
import { Label } from '../../Label';
import api from '../../../services/api';
import { Tooltip, Grid, Divider } from '@mui/material';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
} from '@mui/material';
import { FormGroup } from '../../FormGroup';
import { Options, Select } from '../../Select';
import AttachEmailIcon from '@mui/icons-material/AttachEmail';
import { useNavigate } from 'react-router-dom';
import { DocumentoEmpresa } from '../DocumentoEmpresa';
import PaymentConfirmationModal from '../ModalAsoPagamento';
import { io } from 'socket.io-client';


interface AsoPcmsoProps {
    trabalhadorSelecionado: any | null;
    empresa: any | null;
    cnae: any | null;
}


export const AsoPcmso: React.FC<AsoPcmsoProps> = ({ trabalhadorSelecionado, empresa, cnae }) => {
    const navigate = useNavigate();
    const [funcoes, setFuncoes] = useState([]);
    const [funcaoSelecionada, setFuncaoSelecionada] = useState<any>();
    const [exames, setExames] = useState([]);
    const [riscos, setRiscos] = useState([]);
    const [openPdfModal, setOpenPdfModal] = useState(false);
    const [paymentApproved, setPaymentApproved] = useState(false);
    const [descontoTotal, setDescontoTotal] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [qrCode, setQrCode] = useState('');
    const [alert, setAlert] = useState({ show: false, message: '', variant: 'success' });
    const [uf, setUf]: any = useState('');
    const [crm, setCRM]: any = useState('');
    const [nomeMedico, setNomeMedico]: any = useState('');
    const [progressValue, setProgressValue] = useState(0);
    const [redirectCounter, setRedirectCounter] = useState(3);

    const handleNavigate = () => {
        navigate('/reaproveitamento-aso/aso-pcmso');
    };

    const ufs = [
        { id: 1, nome: 'AC' },
        { id: 2, nome: 'AL' },
        { id: 3, nome: 'AM' },
        { id: 4, nome: 'AP' },
        { id: 5, nome: 'BA' },
        { id: 6, nome: 'CE' },
        { id: 7, nome: 'DF' },
        { id: 8, nome: 'ES' },
        { id: 9, nome: 'GO' },
        { id: 10, nome: 'MA' },
        { id: 11, nome: 'MG' },
        { id: 12, nome: 'MS' },
        { id: 13, nome: 'MT' },
        { id: 14, nome: 'PA' },
        { id: 15, nome: 'PB' },
        { id: 16, nome: 'PE' },
        { id: 17, nome: 'PI' },
        { id: 18, nome: 'PR' },
        { id: 19, nome: 'RJ' },
        { id: 20, nome: 'RN' },
        { id: 21, nome: 'RO' },
        { id: 22, nome: 'RR' },
        { id: 23, nome: 'RS' },
        { id: 24, nome: 'SC' },
        { id: 25, nome: 'SE' },
        { id: 26, nome: 'SP' },
        { id: 27, nome: 'TO' }
    ];

    const handleSelectFuncao = (funcao: any, empresa: any) => {
        setFuncaoSelecionada(funcao);
        fetchExams(funcao);
        fetchRisks(empresa, funcao);
    };

    const transformarPreco = (valor: any) => {
        const valorDividido = valor / 100;
        return valorDividido.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    };

    function handleOpenPdf() {
        setOpenPdfModal(true)
    }

    function handleClosePdf() {
        setOpenPdfModal(false)
    }

    async function handlePayment() {
        try {
            let focusSet = false;

            // Verifica se algum dos campos obrigatórios está vazio
            if (!funcaoSelecionada) {
                if (!focusSet) {
                    const input = document.getElementById('funcaoSelecionada') as HTMLInputElement;
                    if (input) input.focus();
                    focusSet = true;
                }
            } 

            // Se algum campo estava vazio, exibe um alerta geral e sai da função
            if (!funcaoSelecionada ) {
                setAlert({
                    show: true,
                    message: "Por favor, preencha todos os campos obrigatórios.",
                    variant: "warning",
                });
                return;
            }

            // Se houver desconto total
            if (descontoTotal) {
                setPaymentApproved(true);
                handleOpenPdf();
            } else {
                
                // Se não houver desconto total, segue para os detalhes de pagamento
                const paymentDetails = {
                    transaction_value: valorInicialTotal,
                    description: 'Pagamento de Reaproveitamento de ASO por PCMSO',
                    email: 'comercial@medicoatento.com.br', //TODO: Substituir pelo email para gerar Reaproveitamento
                    cpf: 'xxx.xxx.xxx-xx',
                };
                const response = await api.post('/pix/create', paymentDetails);
                setQrCode(response.data.qr_code_base64);
                setShowModal(true);
            }
        } catch (error) {
            console.error('Erro ao criar pagamento PIX:', error);
        }
    };
 
    const fetchFunctions = useCallback(async () => {
        try {
            const response = await api.get(`buscar-funcoes-pcmso-empresa/${empresa.id}`);
            const responseData = response.data.reaproveitamentosPcmso;
            setFuncoes(responseData);
        } catch (error) {
            console.error(error);
        }
    }, [empresa]);

    const fetchExams = useCallback(async (funcaoSelecionada:any) => {
        try {
            setExames([]);
            const response = await api.get(`buscar-exames-pcmso/${empresa.id}/trabalhador/${trabalhadorSelecionado.id}/ghe/${funcaoSelecionada.idGhe}`);
            const responseData = response.data;
            setExames(responseData.examesPcmso);
            setCRM(responseData.infosMedico.crm_medico);
            setNomeMedico(responseData.infosMedico.nome_medico);

            const ufEncontrada = ufs.find((uf) => uf.nome === responseData.infosMedico.uf_crm);
            setUf(ufEncontrada?.nome || '');
        } catch (error) {
            console.error(error);
        }
    }, [empresa]);

    const fetchRisks = useCallback(async (empresa: any, funcao: any) => {
        try {
            setRiscos([]);
            const response = await api.get(`buscar-riscos-empresa/${empresa.id}/ghe/${funcao.idGhe}`);
            const responseData = response.data.riscosFuncaoPcmso;
            setRiscos(responseData);
        } catch (error) {
            console.error(error);
        }
    }, []);

    const valorInicialTotal = useMemo(() => {
        return parseFloat(
            exames.reduce((total: number, exame: { valor: number }) => total + exame.valor / 100, 0).toFixed(2)
        );
    }, [exames]);

    const handleSavePayment = async (data: any, userId: any) => {
        try {
            data.userId = userId;
            await api.post('salvar-pagamento-reaproveitamento', data);
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        if (trabalhadorSelecionado) {
            fetchFunctions();
        }
    }, [trabalhadorSelecionado, fetchFunctions]);

    useEffect(() => {
        const socket = io(`${process.env.REACT_APP_SOCKET_URL}`, { transports: ['websocket', 'polling'] });

        socket.on('paymentStatusUpdated', (data: any) => {
            if (data.status === 'approved') {
                setPaymentApproved(true);
                handleSavePayment(data, empresa.id_usuario);
            }
        });

        return () => {
            socket.off('paymentStatusUpdated');
        };
    }, []);

    useEffect(() => {
        if (paymentApproved) {
            const progressTimer = setInterval(() => {
                setProgressValue((oldValue) => {
                    const newValue = oldValue + 1;
                    if (newValue === 100) {
                        clearInterval(progressTimer);
                        const redirectTimer = setInterval(() => {
                            setRedirectCounter((counter) => {
                                if (counter === 1) {
                                    clearInterval(redirectTimer);
                                    handleOpenPdf();
                                }
                                return counter - 1;
                            });
                        }, 1000);
                    }
                    return newValue;
                });
            }, 100);
        }
    }, [paymentApproved]);

    return (
        <>
            <div style={{
                display: 'flex',
                height: 'auto',
                padding: '10px',
                width: '100%', 
                boxSizing: 'border-box'
            }}>
                <CardContent>
                {funcoes && funcoes.length > 0 ? (
                    <>
                        <h5 style={{ color: '#0463C1', marginBottom: '20px' }}>
                            3º - Selecione a função que deseja:
                        </h5>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <TableContainer component={Paper} style={{ maxHeight: 400, borderRadius: '6px', border: '1px solid #0d6efd' }}>
                                    <Table stickyHeader aria-label="tabela de funções" style={{ borderCollapse: 'collapse' }}>
                                        <TableHead>
                                            <TableRow style={{ backgroundColor: '#0d6efd' }}>
                                                <TableCell
                                                    style={{
                                                        backgroundColor: '#0d6efd',
                                                        color: 'white',
                                                        fontSize: '15px',
                                                        padding: '15px',
                                                        textAlign: 'center',
                                                        fontWeight: 'normal',
                                                        borderBottom: 'none',
                                                    }}
                                                >
                                                    FUNÇÃO
                                                </TableCell>
                                                <TableCell
                                                    style={{
                                                        backgroundColor: '#0d6efd',
                                                        color: 'white',
                                                        fontSize: '15px',
                                                        padding: '15px',
                                                        textAlign: 'center',
                                                        fontWeight: 'normal',
                                                        borderBottom: 'none',
                                                    }}
                                                >
                                                    GHE
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {funcoes.slice(0, 6).map((funcao: any, index: number) => (
                                                <TableRow
                                                    key={funcao.id}
                                                    onClick={() => handleSelectFuncao(funcao, empresa)}
                                                    hover
                                                    style={{
                                                        cursor: 'pointer',
                                                        backgroundColor: funcaoSelecionada?.id === funcao.id ? '#E0F7FA' : '#fff',
                                                        transition: '0.3s',
                                                        borderBottom: 'none',
                                                    }}
                                                    onMouseEnter={(e) => {
                                                        if (!funcaoSelecionada || funcaoSelecionada.id !== funcao.id) {
                                                            e.currentTarget.style.backgroundColor = '#f1f1f1';
                                                        }
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        if (!funcaoSelecionada || funcaoSelecionada.id !== funcao.id) {
                                                            e.currentTarget.style.backgroundColor = '#fff';
                                                        }
                                                    }}
                                                >                            
                                                    <TableCell
                                                        style={{
                                                            padding: '10px',
                                                            fontSize: '15px',
                                                            textAlign: 'center',
                                                            border: 'none',
                                                        }}
                                                    >
                                                        {funcao.nomeFuncao}
                                                    </TableCell>
                                                    <TableCell
                                                        style={{
                                                            padding: '10px',
                                                            fontSize: '15px',
                                                            textAlign: 'center',
                                                            border: 'none',
                                                        }}
                                                    >
                                                        {funcao.nomeGhe}
                                                    </TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>

                            </Grid>
                        </Grid>
                    </>
                ) : (
                        <span style={{ textAlign: 'center' }}>
                            Verificamos que sua empresa não possui um PCMSO cadastrado,  
                            <button onClick={handleNavigate} style={{ background: 'none', border: 'none', color: 'blue', textDecoration: 'underline', cursor: 'pointer', marginLeft:'3px' }}>
                                clique aqui para cadastrá-lo em nossa base.
                            </button>
                        </span>
                    )}
                </CardContent>
            </div>

            {funcaoSelecionada && exames &&(
                <div style={{
                    display: 'flex',
                    height: 'auto',
                    padding: '10px'
                }}>
                    <CardContent>
                        <h5 style={{ color: '#0463C1', marginBottom: '20px' }}>
                            4º - Verifique as informações:
                        </h5>
                        <div>
                            <p>Função selecionada: {funcaoSelecionada?.nomeFuncao}</p> 
                            <Title text="Cadastrar ASO por PCMSO" />
                        </div>
                        <Row>
                                <Col xs={12} md={12} xl={12} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                                    <Row style={{ marginTop: '30px' }}>
                                        <h6 style={{ color: '#808080', textAlign: 'center' }}>Exames Incluídos</h6>
                                    </Row>
                                    <Row style={{ display: 'flex', justifyContent: 'center', overflowX: 'auto', width: '100%', borderRadius: '6px', border: '1px solid #0d6efd' }}>
                                        <table >
                                            <thead>
                                                <tr style={{ backgroundColor: '#0d6efd', color: 'white' }}>
                                                    <th style={{ fontSize: '15px', padding: '15px', textAlign: 'center', fontWeight: 'normal' }}>Ordem</th>
                                                    <th style={{ fontSize: '15px', padding: '15px', textAlign: 'center', fontWeight: 'normal' }}>Exame</th>
                                                    <th style={{ fontSize: '15px', padding: '15px', textAlign: 'center', fontWeight: 'normal' }}>Valor</th>
                                                   
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {exames.map((exame: any, index: number) => {
                                                    return (
                                                        <tr key={exame.id}>
                                                            <td style={{ fontSize: '15px', textAlign: 'center' }}>
                                                                <div>{index + 1}</div>
                                                            </td>
                                                            <td style={{ fontSize: '15px', textAlign: 'center', padding: '6px' }}>
                                                                {exame.nome_exame}
                                                            </td>
                                                            <td style={{ fontSize: '15px', textAlign: 'center', padding: '6px' }}>
                                                                {transformarPreco(exame.valor)}
                                                            </td>
                                                            
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </table>
                                    </Row>
                                    <Row style={{ marginTop: '20px', textAlign: 'center', fontWeight: 'bold' }}>
                                        {exames.length > 0 && (
                                            <h5>Total: R$ {valorInicialTotal}</h5>
                                        )}
                                    </Row>
                                    <Row style={{ marginTop: '30px' }}>
                                        <h6 style={{ color: '#808080', textAlign: 'center' }}>Riscos da função</h6>
                                    </Row>
                                    <Row style={{ display: 'flex', justifyContent: 'center', overflowX: 'auto', width: '100%', borderRadius: '6px', border: '1px solid #0d6efd' }}>
                                        <table >
                                            <thead>
                                                <tr style={{ backgroundColor: '#0d6efd', color: 'white' }}>
                                                    <th style={{ fontSize: '15px', padding: '15px', textAlign: 'center', fontWeight: 'normal' }}>Ordem</th>
                                                    <th style={{ fontSize: '15px', padding: '15px', textAlign: 'center', fontWeight: 'normal' }}>Risco</th>
                                                    <th style={{ fontSize: '15px', padding: '15px', textAlign: 'center', fontWeight: 'normal' }}>Categoria</th>
                                                   
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {riscos.map((risco: any, index: number) => {
                                                    return (
                                                        <tr key={risco.id}>
                                                            <td style={{ fontSize: '15px', textAlign: 'center' }}>
                                                                <div>{index + 1}</div>
                                                            </td>
                                                            <td style={{ fontSize: '15px', textAlign: 'center', padding: '6px' }}>
                                                                {risco.risco}
                                                            </td>
                                                            <td style={{ fontSize: '15px', textAlign: 'center', padding: '6px' }}>
                                                                <Tooltip title={risco.nome_categoria || ''}>
                                                                    <span>
                                                                        {risco.nome_categoria ? risco.nome_categoria : ''}
                                                                    </span>
                                                                </Tooltip>
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </table>
                                    </Row>
                                </Col>
                            </Row>
                            <Row style={{ marginTop: '50px' }}>
                                <hr style={{ width: '100%' }}></hr>
                                <h6 style={{ color: '#0463C1', marginRight: '5px' }}>Informações do Médico Coordenador</h6>
                            </Row>
                            <Row>
                                <Col xs={12} md={4} xl={4}>
                                    <FormGroup>
                                        <Label title='Nome do Médico' htmlFor={''} />
                                        <input type='text' style={{ width: '100%' }} value={nomeMedico} onChange={(e: any) => setNomeMedico(e.target.value)} />
                                    </FormGroup>

                                </Col>
                                <Col xs={12} md={4} xl={4}>
                                    <FormGroup>
                                        <Label title='CRM do Médico' htmlFor={''} />
                                        <input type='text' style={{ width: '100%' }} value={crm} onChange={(e: any) => setCRM(e.target.value)} />
                                    </FormGroup>
                                </Col>
                                <Col xs={12} md={4} xl={4}>
                                    <Label title="UF CRM do Médico" htmlFor={''} />
                                    <Select
                                        id="selectResponsavel"
                                        value={uf}
                                        onSelect={(value: any) => {
                                            const ufSelecionada = ufs.find((tipo) => tipo.nome === value);
                                            setUf(ufSelecionada?.nome || '');
                                        }}
                                    >
                                        {ufs.map((tipo) => (
                                            <Options key={tipo.id} value={tipo.nome} name={tipo.nome} selected={tipo.nome === uf} />
                                        ))}
                                    </Select>
                                </Col>
                            </Row>
                            <Row className="d-flex align-items-center justify-content-center mt-5">
                                <button
                                    className="btn btn-success d-flex align-items-center justify-content-center gap-2"
                                    style={{ width: '100%', maxWidth: '150px', height: '40px', borderRadius: '5px' }}
                                    onClick={handlePayment}
                                >
                                    <AttachEmailIcon style={{ fontSize: '16px' }} />
                                    Enviar
                                </button>
                            </Row>


                            {openPdfModal && (
                                <DocumentoEmpresa
                                    trabalhadorSelecionado={trabalhadorSelecionado}
                                    empresa={empresa}
                                    funcaoSelecionada={funcaoSelecionada}
                                    riscosIncluidos={riscos}
                                    examesCadastrados={exames}
                                    descontoTotal={descontoTotal}
                                    valorInicialTotal={valorInicialTotal}
                                    crm={crm}
                                    nomeMedico={nomeMedico}
                                    uf={uf}
                                    onClose={handleClosePdf}
                                    dadosCnae={cnae}
                                />
                            )}

                            <PaymentConfirmationModal 
                                show={showModal} 
                                handleClose={() => setShowModal(false)}
                                paymentApproved={paymentApproved}
                                progressValue={progressValue}
                                descontoTotal={descontoTotal}
                                valorInicialTotal={valorInicialTotal}
                                qrCode={qrCode}
                            />


                            <AlertMessage
                                show={alert.show}
                                message={alert.message}
                                variant={alert.variant}
                                onClose={() => setAlert({ ...alert, show: false })}
                            />
                    </CardContent>
                </div>
            )}
        </>
    )
}